var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectMic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 253,
    height: 187,
    viewBox: "0 0 253 187",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "sid1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 70,
    width: 253,
    height: 117
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.56 70H0V186.63H252.56V70Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#sid1)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 171.621C192.2 171.621 196.02 169.451 196.02 166.771H178.99C178.99 169.451 182.8 171.621 187.51 171.621H187.5Z",
    fill: "#434556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.56 171.62H186.22V206.78H189.56V171.62Z",
    fill: "#434556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.27 166.771L214.15 166.591C214.15 166.591 221.32 164.851 223.17 161.001C225.62 155.911 226.84 134.821 232.05 116.181H201.07C195.86 134.821 194.64 155.911 192.19 161.001C190.34 164.851 183.17 166.591 183.17 166.591L154.83 166.741L177.27 166.771Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.27 167.851L154.83 167.821C154.24 167.821 153.75 167.341 153.75 166.741C153.75 166.151 154.23 165.661 154.82 165.661L183.03 165.511C184.98 165.011 189.91 163.251 191.21 160.531C192.26 158.351 193.11 152.731 194.2 145.621C195.53 136.911 197.18 126.081 200.03 115.881C200.16 115.411 200.58 115.091 201.07 115.091H232.05C232.39 115.091 232.7 115.251 232.91 115.521C233.11 115.791 233.18 116.141 233.09 116.461C230.28 126.531 228.64 137.291 227.32 145.941C226.17 153.521 225.33 158.991 224.15 161.461C222.1 165.721 214.73 167.551 214.41 167.631C214.33 167.651 214.25 167.661 214.16 167.661L177.28 167.841L177.27 167.851ZM201.88 117.261C199.2 127.101 197.61 137.531 196.33 145.951C195.18 153.531 194.34 159.001 193.16 161.471C192.29 163.281 190.46 164.651 188.61 165.641L214.01 165.521C215.96 165.021 220.89 163.261 222.19 160.541C223.24 158.361 224.09 152.741 225.18 145.631C226.45 137.311 228.01 127.051 230.63 117.261H201.88Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.74 142.59C158.72 142.66 159.09 142.3 156.55 144.07C155.72 144.65 154.06 144.55 151.91 144.68C150.19 144.79 148.68 145.45 148.09 144.91C146.81 143.74 152.47 143.32 152.11 142.97C152.11 142.97 150.62 142.35 148.22 142.7C146.13 143.01 143.14 144.58 142.4 143.45C142.13 143.06 142.85 142.68 144.04 141.85C145.23 141.02 146.84 139.82 148.79 139.37C151.54 138.73 154.16 139.26 157.75 139.26C158.52 139.26 161.14 139.19 162.27 138.51C163.72 137.64 163.04 142.58 162.73 142.58L162.74 142.59Z",
    fill: "#FED0CA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.28 138.521C161.15 139.201 158.53 139.271 157.76 139.271C157.17 139.271 156.61 139.251 156.07 139.231C156.24 139.671 156.52 140.691 156.15 141.901C155.85 142.871 155.21 144.031 153.65 144.611C154.96 144.561 155.97 144.491 156.56 144.081C159.1 142.301 158.72 142.661 162.75 142.601C163.06 142.601 163.74 137.651 162.29 138.531L162.28 138.521Z",
    fill: "#FDB9B1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.47 143.22L157.74 143.28C157.74 143.28 157.98 140.08 156.65 139.2L159.96 138.36L161.32 141.01L160.47 143.23V143.22Z",
    fill: "#FBEDD9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.17 141.48C178.53 142.73 164.24 143.95 159.16 143.96C159.39 143.82 160.25 138.8 158.04 137.36C161.44 136.23 175.2 131.64 178.87 132.1C179.25 128.33 180.28 120.69 183.37 109.81C184.3 106.57 186.85 105.14 190.24 106.95C192.53 108.17 193.7 111.64 193.79 113.95C194.17 122.99 185.54 141.18 184.17 141.48Z",
    fill: "url(#sid2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M191.34 107.791C191.01 107.451 190.64 107.171 190.23 106.951C186.84 105.151 184.28 106.571 183.36 109.811C183.33 109.901 183.31 110.001 183.28 110.091C183.21 110.711 183.13 111.361 182.98 112.061C180.54 123.521 185.74 130.971 184.32 139.691C184.19 140.491 183.99 141.051 183.79 141.561C183.92 141.531 184.05 141.511 184.16 141.481C184.69 141.361 186.33 138.531 188.1 134.581C187.9 124.021 189.15 114.161 191.33 107.801L191.34 107.791Z",
    fill: "url(#sid3)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.74 150.09C196.18 147.64 197.17 141.07 194.07 140.93C190.6 140.77 184.14 147.94 180.84 148.66C168.89 151.25 159.99 158.31 152.64 164.82C149.11 167.95 140.25 204.5 135.74 210.73C138.51 211.68 146.01 213.48 148.95 213.61C150.59 207.89 161.4 183.26 162.34 176.42C162.6 174.49 165.58 172.64 167.55 171.62C176.3 167.12 179.26 162.85 187.91 162.2C189.75 162.06 191.65 161.9 193.26 161.03C197.22 158.89 197.63 153.95 196.75 150.1L196.74 150.09Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M209.75 153.59C209.28 151.12 210.13 146.13 207.04 145.89C204.58 145.7 191.61 140.49 191.41 143.52C191.28 145.42 190.35 148.44 193.42 151.7C177.93 153.46 172.74 160.61 165.18 166.88C161.57 169.87 167.02 209.11 165.57 213.6C168.24 214.77 174.97 214.14 177.88 214.39C178.56 200.28 179.75 189.5 178.52 182.18C177.37 175.31 176.09 173.15 178.1 172.2C187 167.99 191.85 165.78 200.51 165.4C202.35 165.32 204.26 165.22 205.9 164.4C209.93 162.39 210.51 157.47 209.76 153.59H209.75Z",
    fill: "#1E1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.55 143.641C185.36 135.051 185.04 119.581 184.76 115.331C184.49 111.251 184.39 106.801 188.15 104.651C192.46 102.201 203.4 101.901 207.75 103.331C211.21 104.461 214.78 105.731 215.51 108.701C216.19 111.441 216.21 116.271 215.2 118.911C205.29 144.821 208.37 143.911 206.88 150.031C206.72 150.681 188.46 147.231 187.55 143.641Z",
    fill: "#F8DEBB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.71 116.931C218.1 124.551 211.59 133.941 213.24 140.401C215.5 149.221 212.04 160.941 210.72 163.171C209.85 163.171 209.06 163.001 208.34 162.691C202.98 160.401 201.29 150.651 193.83 149.731C200.36 144.371 193.12 122.921 206.76 102.471C215.99 105.121 216.98 105.821 219.21 110.131C220.22 112.091 220.23 114.421 219.7 116.941L219.71 116.931Z",
    fill: "url(#sid4)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.95 111.49L195.09 111.29C195.09 111.29 187.97 136.55 189.05 142.86L191.38 146.01L194.62 142.55C194.62 142.55 195.39 117.71 196.96 111.49H196.95Z",
    fill: "url(#sid5)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199.05 107.731L196.96 111.501L195.1 111.301C195.1 111.301 195.01 107.291 195.31 107.441C195.61 107.591 199.05 107.731 199.05 107.731Z",
    fill: "url(#sid6)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M184.06 112.06C184.9 108.09 183.4 105.59 192.2 102.93C192.89 102.72 194.1 102.81 194.85 102.74C190.12 109.24 187.66 128.94 190.14 147.38C186.55 146.05 185.01 147.4 184.04 146.82C183.76 142.38 184.94 142.43 185.39 139.69C186.81 130.97 181.61 123.52 184.05 112.06H184.06Z",
    fill: "url(#sid7)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M188.61 108.151C188.84 108.341 189.72 108.611 189.95 108.811C188.87 108.811 188.07 109.131 187.42 109.171C186.81 113.851 187.33 124.661 189.12 130.811C189.96 119.721 190.06 119.241 190.57 116.221C190.67 115.621 192.3 107.721 193.01 106.231C194.04 104.051 194.37 103.601 194.86 102.741C193.11 101.591 189.47 107.201 188.62 108.151H188.61Z",
    fill: "url(#sid8)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M213.24 140.4C215.5 149.22 212.04 160.94 210.72 163.17C209.85 163.17 209.06 163 208.34 162.69C207.94 161.53 213.33 148.7 204.61 141.5C203.18 140.32 201.81 138.24 202.99 136.39C204.37 134.21 205.53 132.1 206.46 129.7C207.7 126.45 208.03 122.88 208.63 119.48C208.91 117.88 209.14 116.18 209.79 114.68C210.14 113.88 211.18 111.88 212.16 112.04C211.76 110.75 215.94 113.3 216.57 113.76C217.75 114.62 218.8 115.7 219.7 116.94C218.09 124.56 211.58 133.95 213.23 140.41L213.24 140.4Z",
    fill: "url(#sid9)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M213.44 167.491C213.27 167.491 213.11 167.451 212.95 167.371C212.42 167.101 212.21 166.451 212.48 165.921L221.71 147.871C221.97 147.361 222.01 146.841 221.8 146.511C221.55 146.101 220.89 145.871 219.95 145.871H191.51C190.44 145.871 189.68 146.071 189.48 146.411C189.08 147.091 190.08 148.931 190.51 149.721L199.33 165.891C199.62 166.411 199.42 167.071 198.9 167.351C198.38 167.641 197.72 167.441 197.44 166.921L188.64 150.781C187.87 149.361 186.6 147.041 187.63 145.301C188.26 144.241 189.56 143.711 191.51 143.711H219.95C222.16 143.711 223.18 144.621 223.64 145.381C224.24 146.361 224.24 147.661 223.63 148.851L214.4 166.901C214.21 167.271 213.83 167.491 213.44 167.491Z",
    fill: "#434556"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M222.69 143.181H192.07C191.683 143.181 191.37 143.494 191.37 143.881V143.961C191.37 144.347 191.683 144.661 192.07 144.661H222.69C223.077 144.661 223.39 144.347 223.39 143.961V143.881C223.39 143.494 223.077 143.181 222.69 143.181Z",
    fill: "#1E1E1E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M205.76 100.661C206.71 102.601 200.02 107.041 196.49 106.801C195.05 106.701 194.34 102.371 194.46 102.151C194.78 101.551 194.67 100.431 194.35 97.2705C194.17 95.5105 196.42 94.9205 199.55 93.5805C201.48 92.7505 205.8 91.4405 205.43 92.7805C204.55 95.9805 204.88 98.8805 205.75 100.661H205.76Z",
    fill: "#FDB9B1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M201.92 96.1904C201.12 97.3304 195.28 99.7504 194.47 99.9304C193.09 100.23 193.06 99.8504 191.51 99.8104C190.59 99.7904 190.45 96.4604 189.98 94.0804C189.39 91.1504 189.83 89.1204 189.98 86.2804C190.07 84.5404 190.48 83.2604 191.18 82.2704C191.56 81.7304 192.03 81.2704 192.59 80.8804C193.02 80.5704 193.59 80.3204 194.24 80.1304C197.79 79.0504 203.91 79.6104 204.57 82.3304C205.13 84.6304 203.26 94.3104 201.93 96.2004L201.92 96.1904Z",
    fill: "#FED0CA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.1 83.4808C201.47 82.8808 200.89 82.4208 199.95 82.4108C197.48 82.3808 195.09 83.9808 192.56 83.2308C191.99 83.0608 191.41 82.7708 191.18 82.2708C191.56 81.7308 192.03 81.2708 192.59 80.8808C193.02 80.5708 193.59 80.3208 194.24 80.1308C194.62 80.0708 195 80.0108 195.38 79.9908C197.01 79.8808 199.1 79.8108 200.64 80.4108C201.64 80.8008 202.82 82.4408 202.11 83.4908L202.1 83.4808Z",
    fill: "#FDB9B1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M191.83 80.0405C192.17 79.4905 195.38 78.0405 196.01 77.9005C196.43 77.8105 208.5 75.6605 208.46 84.9405C208.44 89.7405 204.52 96.9905 204.65 96.2805C205.83 89.7505 204.26 90.5305 202.75 91.4505C203.63 87.5205 202.26 80.9705 199.72 81.7205C195.25 83.0505 190.53 82.1505 191.83 80.0405Z",
    fill: "url(#sid10)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32,
    d: "M206.5 79.8301C206.08 80.8001 205.42 81.6701 204.56 82.3201C203.73 82.9501 202.84 83.2701 202.01 83.4101C202.96 85.4901 203.3 88.9801 202.74 91.4501C204.25 90.5301 205.82 89.7501 204.64 96.2801C204.51 96.9901 208.44 89.7401 208.45 84.9401C208.45 82.5601 207.67 80.9401 206.49 79.8401L206.5 79.8301Z",
    fill: "url(#sid11)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.02 90.9506C202.1 92.3006 202.03 93.8506 202.88 94.4006C203.73 94.9506 205.17 94.3106 206.09 92.9506C207.01 91.6006 207.08 90.0506 206.23 89.5006C205.38 88.9506 203.94 89.5906 203.02 90.9506Z",
    fill: "#FED0CA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M193.94 93.7303C197.45 93.8403 196.06 96.9403 197.18 96.7003C200.26 96.0403 202.92 90.6503 203.31 89.8203C202.71 93.0103 202.43 95.5503 201.63 96.7903C200.39 98.7003 195 100.52 194.19 100.7C192.81 101 192.78 100.62 191.23 100.58C190.36 100.56 189 94.4403 189.73 93.9103C190.13 92.6703 192.81 93.7003 193.95 93.7403L193.94 93.7303Z",
    fill: "url(#sid12)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M192.42 97.94C193.25 97.97 194.44 99.19 195.04 95.23C194.71 95.21 194.92 95.22 194.44 95.15C193.24 94.99 191.82 94.74 191.2 94.61C191.04 94.58 190.94 94.55 190.9 94.54C190.83 97.78 191.37 97.9 192.42 97.94Z",
    fill: "#FED0CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.12 107.18C202.87 108.68 201.61 110.17 200.36 111.67C200.44 111.57 198.3 109 197.23 107.7C195.17 108.33 194.34 109.49 192.72 110.82C192.32 108.18 193.23 104.94 194.58 102.58C194.85 102.4 194.85 102.99 194.85 103.46C194.85 105.45 195.68 105.58 197.12 107.31C197.86 107.22 199.74 106.35 200.89 105.46C201.72 104.82 204.43 102.49 205.46 101.24C206.05 100.53 205.45 102.29 206.73 103.06C206.49 103.8 204.77 106.38 204.11 107.17L204.12 107.18Z",
    fill: "#FBEDD9"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.12 106.461C202.87 107.961 201.61 109.451 200.36 110.951C200.44 110.851 198.3 108.281 197.23 106.981C195.17 107.611 194.34 108.771 192.72 110.101C192.32 107.461 193.23 104.221 194.58 101.861C194.85 101.681 194.85 102.271 194.85 102.741C194.85 104.731 195.68 104.861 197.12 106.591C197.86 106.501 199.74 105.631 200.89 104.741C201.72 104.101 204.43 101.771 205.46 100.521C206.05 99.8108 205.45 101.571 206.73 102.341C206.49 103.081 204.77 105.661 204.11 106.451L204.12 106.461Z",
    fill: "#FBEDD9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M208.3 102.92C208.3 103.09 206.64 107.51 206.59 109.52C205.89 109.7 205.37 109.52 204.79 109.76C205.45 110.13 206.34 110.34 207.09 110.7C205.45 112.83 200.69 121.93 197.58 132.34C197.29 131.37 198.77 112.15 205.75 102.74C206.09 102.29 205.78 101.23 206.41 101.55C206.94 101.81 208.29 102.4 208.29 102.94L208.3 102.92Z",
    fill: "url(#sid13)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M192.85 139.611C192.22 139.511 190 140.901 189.1 141.211C187.22 141.871 185.75 142.591 184.4 144.041C183.76 144.741 181.05 151.121 182.29 151.351C183.46 151.561 183.52 147.971 183.6 147.401C183.45 148.081 183.01 152.731 183.71 152.891C184.87 153.171 184.65 148.381 184.59 147.891C184.55 148.591 184.33 152.341 184.91 152.761C186.31 153.781 185.95 148.531 186.08 148.121C186.01 149.101 185.95 152.561 187.04 152.371C187.64 152.301 187.52 150.641 187.49 149.621C187.46 148.211 187.62 146.811 188.88 146.251C190.48 145.531 191.97 145.781 193.29 144.471C194.03 143.741 194.04 143.751 195.19 143.441C196.02 143.211 196.56 143.141 196.54 142.201C196.52 141.441 195.38 139.581 194.6 139.351C193.96 139.171 192.92 139.531 192.83 139.611H192.85Z",
    fill: "#FED0CA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M194.62 139.351C193.98 139.171 192.94 139.531 192.85 139.611C192.6 139.571 192.09 139.771 191.52 140.041C191.98 140.611 192.57 141.581 192.44 142.721C192.23 144.531 188.65 144.081 187.41 146.091C186.92 146.891 186.67 148.201 187.53 150.481C187.53 150.181 187.51 149.881 187.51 149.631C187.48 148.221 187.64 146.821 188.9 146.261C190.5 145.541 191.99 145.791 193.31 144.481C194.05 143.751 194.06 143.761 195.21 143.451C196.04 143.221 196.58 143.151 196.56 142.211C196.54 141.451 195.4 139.591 194.62 139.361V139.351Z",
    fill: "#FDB9B1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M191.43 139.621C191.43 139.621 194.18 142.911 193.88 144.061L195.96 144.401L194.47 139.101L191.43 139.631V139.621Z",
    fill: "#FBEDD9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M220.95 142.24C214.44 144.94 198.68 144.95 194.86 144.84C195.4 143.34 194.63 140.84 193.52 138.62C195.74 138.18 205.73 135.82 210.18 135.05C211.07 134.9 211.74 134.8 212.08 134.8C212.13 134.28 212.12 133.74 212.08 133.16C211.8 129.82 210.15 125.39 210.56 116.4C210.73 112.65 212.22 106.71 216.99 106.97C219.47 107.1 220.8 111.3 221.13 116.19C221.72 124.82 222.19 141.74 220.96 142.25L220.95 142.24Z",
    fill: "url(#sid14)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M214.67 136.79C214.29 136.84 213.86 136.46 213.57 136.26C213.01 135.88 212.47 135.6 211.8 135.44C211.25 135.31 210.69 135.23 210.17 135.04C211.06 134.89 211.73 134.79 212.07 134.79C212.12 134.27 212.11 133.73 212.07 133.15C212.21 133.55 212.38 133.94 212.56 134.31C212.8 134.8 213.11 135.23 213.48 135.62C213.76 135.92 214.6 136.38 214.68 136.78L214.67 136.79Z",
    fill: "url(#sid15)"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M184.59 147.9C184.57 148.34 184.47 150.01 184.55 151.29C184.71 149.94 184.62 148.19 184.59 147.9Z",
    fill: "#FED0CA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M183.38 149.53C183.53 148.63 183.57 147.67 183.6 147.41C183.54 147.68 183.44 148.56 183.38 149.53Z",
    fill: "#FED0CA"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M181.33 134.28C180.94 134.31 180.55 133.9 180.26 133.68C179.72 133.26 179.2 132.95 178.55 132.75C178.01 132.58 177.42 132.38 176.91 132.16C177.9 132.02 178.52 132.08 178.86 132.1C178.9 131.61 178.95 131.23 179.04 130.48C179.15 130.89 179.21 131.31 179.37 131.68C179.58 132.18 179.86 132.63 180.21 133.04C180.47 133.36 181.28 133.87 181.33 134.28Z",
    fill: "url(#sid16)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M144.52 143.27C143.68 143.55 142.79 143.42 142.36 143.33C142.36 143.37 142.38 143.41 142.41 143.45C143.15 144.58 146.15 143.01 148.23 142.7C150.63 142.35 152.12 142.97 152.12 142.97C152.12 142.97 150.19 141.71 149.08 141.76C147.97 141.81 145.7 142.88 144.53 143.26L144.52 143.27Z",
    fill: "#FDB9B1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.72 97.5709L158.8 97.6209L169.53 105.621L165.6 97.5909L174.61 97.7009C175.78 97.7109 176.74 96.7709 176.75 95.6009L176.84 80.6809C176.84 79.5109 175.91 78.5609 174.74 78.5609L150.83 78.4209C149.66 78.4209 148.71 79.3509 148.71 80.5209L148.62 95.4509C148.62 96.6209 149.55 97.5709 150.72 97.5709Z",
    fill: "url(#sid17)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M168.63 88.0207C168.63 87.7207 168.54 87.4707 168.36 87.2707C168.18 87.0707 167.92 86.9707 167.56 86.9707C167.2 86.9707 166.94 87.0707 166.75 87.2707C166.57 87.4707 166.47 87.7207 166.47 88.0207C166.47 88.3207 166.56 88.5407 166.75 88.7407C166.93 88.9307 167.2 89.0307 167.56 89.0307C167.92 89.0307 168.18 88.9307 168.36 88.7407C168.54 88.5507 168.63 88.3107 168.63 88.0207Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M163.6 88.0207C163.6 87.7207 163.51 87.4707 163.33 87.2707C163.15 87.0707 162.89 86.9707 162.53 86.9707C162.17 86.9707 161.91 87.0707 161.72 87.2707C161.54 87.4707 161.44 87.7207 161.44 88.0207C161.44 88.3207 161.53 88.5407 161.72 88.7407C161.9 88.9307 162.17 89.0307 162.53 89.0307C162.89 89.0307 163.15 88.9307 163.33 88.7407C163.51 88.5507 163.6 88.3107 163.6 88.0207Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M158.8 88.0207C158.8 87.7207 158.71 87.4707 158.53 87.2707C158.35 87.0707 158.09 86.9707 157.73 86.9707C157.37 86.9707 157.11 87.0707 156.92 87.2707C156.74 87.4707 156.64 87.7207 156.64 88.0207C156.64 88.3207 156.73 88.5407 156.92 88.7407C157.1 88.9307 157.37 89.0307 157.73 89.0307C158.09 89.0307 158.35 88.9307 158.53 88.7407C158.71 88.5507 158.8 88.3107 158.8 88.0207Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M128.35 153.211H115.99V225.731H128.35V153.211Z",
    fill: "#808080"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M240.51 152.341C240.51 157.381 188.1 161.461 123.45 161.461C58.8 161.461 6.39 157.371 6.39 152.341C6.39 147.311 58.8 143.221 123.45 143.221C182.04 143.221 231.93 145.221 240.51 149.601V152.341Z",
    fill: "url(#sid18)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M123.45 158.711C188.1 158.711 240.51 154.628 240.51 149.591C240.51 144.554 188.1 140.471 123.45 140.471C58.7995 140.471 6.39 144.554 6.39 149.591C6.39 154.628 58.7995 158.711 123.45 158.711Z",
    fill: "url(#sid19)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M142.75 150.661L115.53 150.451C115.16 150.451 114.92 150.071 115.08 149.731L122.95 132.681C123.03 132.501 123.21 132.391 123.41 132.391L150.63 132.601C151 132.601 151.24 132.981 151.08 133.321L143.21 150.371C143.13 150.551 142.95 150.661 142.75 150.661Z",
    fill: "url(#sid20)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M141.99 149.411L116.67 149.211L123.76 133.871L149.08 134.071L141.99 149.411Z",
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.99 149.41L116.67 149.21L119.99 149.23L138.87 133.99L149.08 134.07L141.99 149.41Z",
    fill: "white"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M115.07 149.73L100.16 151.7L100.11 153.3L133.82 154.84L143.09 151.57L143.21 150.37",
    fill: "url(#sid21)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M71.12 103.851C71.04 107.561 67.79 104.431 67.72 103.201C67.65 101.971 68.06 101.031 68.94 100.991C69.82 100.951 71.15 102.621 71.12 103.851Z",
    fill: "#FDB9B1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M84.91 101.42C84.35 105.13 83.42 107.58 81.24 111.94C81.24 111.95 81.22 111.97 81.2 111.98C80.84 112.18 78.57 111.98 78.32 111.84C71.97 108.19 72.05 107.16 71.7 104.83C71.62 104.27 71.51 103.64 71.28 102.87C70.49 100.22 69.98 95.6704 71.55 93.5304C72.34 92.4504 73.61 91.6004 75.07 91.6004C75.72 91.6604 78.8 91.2504 81.43 92.9404C84.06 94.6304 85.55 97.1004 84.91 101.44V101.42Z",
    fill: "#FED0CA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2 112.011C80.84 112.121 78.57 112.011 78.32 111.931C71.97 109.851 72.05 109.271 71.7 107.941C71.86 107.891 78.14 102.651 81.41 101.971C82.94 101.651 82.44 105.041 82.4 105.131C80.38 110.201 81.39 111.741 81.19 112.011H81.2Z",
    fill: "#FDB9B1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M82.17 103.851C82.25 107.561 85.5 104.431 85.57 103.201C85.64 101.971 85.23 101.031 84.35 100.991C83.47 100.951 82.14 102.621 82.17 103.851Z",
    fill: "#FDB9B1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M68.31 115.371C70.54 114.641 71.85 112.171 81.78 116.041C80.7 114.341 80.56 109.631 80.84 105.811C80.99 103.691 79.92 107.051 76.38 105.531C74.19 104.581 70.05 103.891 70.3 105.521C71.16 111.181 69.6 112.991 68.31 115.371Z",
    fill: "#FDB9B1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M86.58 93.4405C86.75 92.6705 86.68 91.9905 86.43 91.3705C85.44 88.9005 81.65 87.5505 79.23 86.9305C72.15 85.1005 68.45 88.0605 67.1 92.3305C67.07 92.3605 67.05 92.3905 67.02 92.4105C63.04 96.6805 67.78 101.76 69.49 104.22C70.26 105.33 70.86 108.45 71.58 109.23C72.52 109.5 75.8 109.18 78.12 109.72C80.19 106.82 80.73 106.27 83.82 101.66C84.27 100.99 89.09 97.3005 86.58 93.4505V93.4405Z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M86.64 93.54C85.76 97.48 82.59 102.13 77.8 103.61C73.75 104.86 67.58 99.74 65.73 94.52C64.5 98.24 68.06 102.15 69.49 104.21C70.26 105.32 70.86 108.44 71.58 109.22C72.52 109.49 75.8 109.17 78.12 109.71C80.19 106.81 80.73 106.26 83.82 101.65C84.26 100.99 89 97.36 86.64 93.55V93.54Z",
    fill: "#1A1A1A"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.44 106.75C69.46 106.83 69.47 106.9 69.32 107.11C69.33 106.99 69.37 106.87 69.44 106.75Z",
    fill: "#FDB9B1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M97.09 178.91C97.92 181.25 97.48 184.36 97.84 186.89C98.45 191.18 99.36 195.5 100.37 199.72C101.45 204.21 102.93 208.5 104.24 212.91C104.64 214.26 104.71 215.45 105.74 218.24C102.92 222.04 96.2 224.54 93.55 223.61C89.52 215.59 87.16 207.39 84.12 197.24C82.32 191.23 80.27 176.04 88.75 174.38C95.03 173.15 98.02 178.77 97.77 184.12L97.1 178.92L97.09 178.91Z",
    fill: "url(#sid22)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.39 115.39C66.56 115.36 68.94 112.42 72.3 112.18C75.66 111.94 83.86 113.69 85.06 115.36L66.39 115.38V115.39Z",
    fill: "url(#sid23)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8 169.77C57.13 172.25 58.91 177.19 60.22 179.53C62.37 183.37 65.25 185.45 68.76 185.5C76.71 185.61 78.89 185.44 88.14 184.26C94.04 183.5 98.25 185.36 107.4 184.99C107.29 191.6 113.68 202.37 116.16 208.36C118.23 213.36 121.54 217.39 122.94 222.45C126.62 223.06 128.19 222.83 134.75 218.72C132.64 211.12 130.17 203.24 127.68 195.66C125.58 189.29 120.88 177.99 119.58 174.74C118.61 172.3 104.85 167.4 97.55 166.49C88.46 165.36 87.31 165.52 82.44 164.86L58.8 169.78V169.77Z",
    fill: "url(#sid24)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M58.88 172.161C56.45 168.481 59.45 160.921 58.9 156.751C57.57 146.781 55.48 133.061 55.7 128.271C55.91 123.681 55.65 122.311 58.86 118.741C63.81 113.241 83.03 114.141 87.84 116.101C92.66 118.061 93.59 119.041 94.03 122.481C94.44 125.661 93.29 132.791 91.84 135.551C81.53 155.251 84.44 156.771 85.54 161.301C85.75 162.181 91.21 165.221 89.63 166.281C88.91 166.761 63.58 179.281 58.87 172.151L58.88 172.161Z",
    fill: "#1E1E1E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M108.23 150.05C109.02 149.15 110.89 149.04 110.89 149.04C110.89 149.04 112.36 154.98 111.43 155.76C110.5 156.54 108.79 155.62 108.79 155.62L108.23 150.05Z",
    fill: "url(#sid25)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M93.57 131.631C92.37 135.571 89.22 142.701 88.69 147.631C89.86 147.761 106.75 147.731 109.69 148.281C109.79 150.331 111.33 152.491 110.51 156.531C105.36 156.641 90.54 157.701 83.97 157.071C80.72 156.761 77.75 155.721 77.25 152.311C76.16 144.851 76.37 136.001 79.28 129.181C81.55 123.861 86.23 115.961 91.96 118.011C99.16 120.591 94.81 127.581 93.58 131.621L93.57 131.631Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M80.64 189.891C75.87 189.891 72 187.691 72 184.971H89.27C89.27 187.681 85.4 189.891 80.63 189.891H80.64Z",
    fill: "#434556"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M91.02 184.981L53.62 184.801C53.62 184.801 46.35 183.041 44.47 179.131C41.99 173.961 40.75 152.581 35.47 133.671H66.89C72.17 152.571 73.41 173.961 75.89 179.131C77.77 183.041 85.04 184.801 85.04 184.801L116.18 184.951L91.02 184.981Z",
    fill: "#808080"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M91.02 186.061L53.62 185.881C53.54 185.881 53.45 185.871 53.37 185.851C53.05 185.771 45.58 183.921 43.51 179.601C42.31 177.101 41.46 171.551 40.29 163.861C38.95 155.091 37.29 144.171 34.44 133.961C34.35 133.631 34.42 133.291 34.62 133.021C34.82 132.751 35.14 132.591 35.48 132.591H66.9C67.38 132.591 67.81 132.911 67.94 133.381C70.83 143.721 72.5 154.711 73.85 163.531C74.95 170.751 75.82 176.451 76.88 178.661C78.21 181.431 83.21 183.221 85.19 183.721L116.2 183.871C116.79 183.871 117.27 184.361 117.27 184.951C117.27 185.541 116.79 186.031 116.19 186.031L91.03 186.061H91.02ZM53.75 183.721L79.58 183.851C77.69 182.851 75.81 181.451 74.92 179.601C73.72 177.101 72.87 171.551 71.7 163.861C70.4 155.311 68.79 144.731 66.07 134.751H36.88C39.54 144.681 41.13 155.101 42.41 163.541C43.51 170.761 44.38 176.461 45.44 178.671C46.77 181.431 51.77 183.221 53.75 183.731V183.721Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M85.61 186.001C85.22 186.001 84.84 185.791 84.65 185.411L75.29 167.101C74.68 165.901 74.67 164.591 75.28 163.601C75.75 162.831 76.78 161.921 79.01 161.921H107.85C109.82 161.921 111.14 162.461 111.77 163.531C112.81 165.281 111.53 167.631 110.76 169.041L101.82 185.441C101.53 185.961 100.88 186.161 100.36 185.871C99.84 185.581 99.64 184.931 99.93 184.411L108.86 168.041C109.31 167.211 110.34 165.331 109.93 164.641C109.72 164.291 108.95 164.091 107.86 164.091H79.02C78.06 164.091 77.38 164.321 77.13 164.741C76.92 165.081 76.96 165.621 77.22 166.141L86.58 184.451C86.85 184.981 86.64 185.631 86.11 185.901C85.95 185.981 85.79 186.021 85.62 186.021L85.61 186.001Z",
    fill: "#434556"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M78.82 163.001H108.24C108.621 163.001 108.93 162.692 108.93 162.311V162.231C108.93 161.85 108.621 161.541 108.24 161.541H78.82C78.4389 161.541 78.13 161.85 78.13 162.231V162.311C78.13 162.692 78.4389 163.001 78.82 163.001Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M111.01 149.641L117.46 147.131C117.46 147.131 120.86 150.301 121.04 151.731C121.22 153.161 119.85 154.721 119.01 154.721C118.17 154.721 111.54 154.901 111.54 154.901C111.54 154.901 111.3 150.361 111 149.641H111.01Z",
    fill: "#FED0CA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sid26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.15 15.5998C120.5 17.4598 121.72 19.0398 123.38 19.8998C123.38 19.8998 123.4 19.8998 123.41 19.9098C123.57 19.9898 123.74 20.0698 123.91 20.1398C123.94 20.1498 123.97 20.1598 124 20.1698C124.15 20.2298 124.31 20.2898 124.47 20.3298C124.53 20.3498 124.58 20.3598 124.64 20.3698C124.78 20.4098 124.91 20.4398 125.05 20.4698C125.15 20.4898 125.25 20.4998 125.35 20.5098C125.45 20.5298 125.55 20.5398 125.66 20.5598C125.87 20.5798 126.07 20.5898 126.28 20.5898C126.49 20.5898 126.7 20.5798 126.9 20.5598C127 20.5498 127.11 20.5298 127.21 20.5098C127.31 20.4998 127.41 20.4798 127.5 20.4698C127.64 20.4398 127.78 20.3998 127.91 20.3698C127.97 20.3498 128.02 20.3398 128.08 20.3298C128.24 20.2798 128.4 20.2298 128.55 20.1698C128.58 20.1598 128.61 20.1498 128.64 20.1398C128.81 20.0698 128.98 19.9898 129.14 19.9098C129.14 19.9098 129.16 19.9098 129.17 19.8998C130.53 19.1998 131.6 18.0098 132.13 16.5798C132.25 16.2698 132.34 15.9398 132.4 15.5998C132.4 15.5798 132.4 15.5598 132.41 15.5298C132.47 15.1998 132.5 14.8598 132.5 14.5198V6.07977C132.5 5.59977 132.44 5.12977 132.33 4.67977C132.17 4.00977 131.89 3.38977 131.52 2.81977C131.34 2.54977 131.14 2.28977 130.92 2.04977C130.9 2.02977 130.89 2.01977 130.87 1.99977C130.65 1.75977 130.41 1.53977 130.16 1.33977C130.16 1.33977 130.15 1.32977 130.14 1.31977C129.89 1.11977 129.62 0.949766 129.33 0.789766C129.32 0.789766 129.3 0.769766 129.29 0.769766C129.02 0.619766 128.73 0.499766 128.44 0.389766C128.39 0.369766 128.34 0.349766 128.29 0.339766C128 0.239766 127.71 0.159766 127.4 0.109766C127.35 0.109766 127.3 0.0897656 127.25 0.0897656C126.93 0.0397656 126.61 0.00976562 126.27 0.00976562C125.93 0.00976562 125.61 0.0397656 125.29 0.0897656C125.24 0.0897656 125.19 0.0997656 125.14 0.109766C124.84 0.169766 124.54 0.239766 124.25 0.339766C124.2 0.359766 124.15 0.369766 124.1 0.389766C123.81 0.499766 123.52 0.619766 123.25 0.769766C123.24 0.769766 123.22 0.789766 123.21 0.789766C122.93 0.949766 122.66 1.11977 122.41 1.31977C122.41 1.31977 122.4 1.32977 122.39 1.33977C122.14 1.53977 121.9 1.75977 121.68 1.99977C121.66 2.01977 121.65 2.02977 121.63 2.04977C121.41 2.28977 121.21 2.54977 121.03 2.81977C120.41 3.75977 120.05 4.87977 120.05 6.07977V14.5298C120.05 14.8798 120.09 15.2098 120.14 15.5398C120.14 15.5598 120.14 15.5798 120.15 15.5998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.03 10.4404C137.2 10.4404 136.51 11.1204 136.51 11.9604V14.6604V14.6704C136.51 14.6704 136.51 14.7004 136.51 14.7204C136.51 15.1304 136.48 15.5304 136.43 15.9304C136.42 16.0504 136.39 16.1704 136.38 16.2804C136.34 16.5704 136.28 16.8504 136.21 17.1204C136.18 17.2404 136.15 17.3604 136.12 17.4804C136.04 17.7804 135.94 18.0704 135.83 18.3604C135.8 18.4404 135.78 18.5104 135.75 18.5904C135.6 18.9604 135.43 19.3104 135.24 19.6604C134.78 20.4904 134.21 21.2404 133.55 21.9104C133.38 22.0804 133.2 22.2404 133.03 22.3904C132.96 22.4504 132.9 22.5204 132.83 22.5804C132.65 22.7304 132.46 22.8704 132.27 23.0104C132.19 23.0704 132.12 23.1304 132.04 23.1804C131.85 23.3104 131.65 23.4304 131.44 23.5504C131.35 23.6004 131.27 23.6604 131.19 23.7004C130.99 23.8104 130.78 23.9104 130.57 24.0004C130.48 24.0404 130.38 24.1004 130.29 24.1404C130.08 24.2304 129.87 24.3004 129.66 24.3804C129.55 24.4204 129.45 24.4604 129.35 24.4904C129.14 24.5604 128.92 24.6104 128.7 24.6604C128.59 24.6904 128.48 24.7204 128.36 24.7504C128.14 24.8004 127.91 24.8204 127.68 24.8504C127.56 24.8704 127.45 24.8904 127.34 24.9004C127.01 24.9304 126.68 24.9504 126.35 24.9504C126.33 24.9504 126.31 24.9504 126.29 24.9504C126.27 24.9504 126.25 24.9504 126.23 24.9504C125.89 24.9504 125.56 24.9304 125.24 24.9004C125.12 24.8904 125.01 24.8604 124.9 24.8504C124.67 24.8204 124.44 24.7904 124.22 24.7404C124.11 24.7204 124 24.6804 123.88 24.6504C123.66 24.6004 123.44 24.5504 123.23 24.4804C123.12 24.4504 123.02 24.4004 122.92 24.3704C122.71 24.3004 122.49 24.2204 122.29 24.1304C122.19 24.0904 122.11 24.0404 122.01 24.0004C121.8 23.9004 121.59 23.8104 121.39 23.7004C121.3 23.6504 121.23 23.6004 121.14 23.5504C120.94 23.4304 120.73 23.3104 120.54 23.1804C120.46 23.1304 120.39 23.0704 120.32 23.0104C120.13 22.8704 119.93 22.7304 119.75 22.5804C119.68 22.5204 119.61 22.4604 119.55 22.3904C119.37 22.2304 119.19 22.0804 119.03 21.9104C118.37 21.2404 117.8 20.4904 117.34 19.6604C117.15 19.3204 116.98 18.9604 116.83 18.5904C116.8 18.5204 116.78 18.4404 116.75 18.3604C116.64 18.0704 116.54 17.7804 116.46 17.4804C116.43 17.3604 116.4 17.2404 116.37 17.1204C116.3 16.8404 116.25 16.5604 116.2 16.2804C116.18 16.1604 116.16 16.0504 116.15 15.9304C116.1 15.5304 116.07 15.1304 116.07 14.7204C116.07 14.7004 116.07 14.6904 116.07 14.6704V11.9604C116.07 11.1304 115.39 10.4404 114.55 10.4404C113.71 10.4404 113.03 11.1204 113.03 11.9604V14.6604C113.03 14.6604 113.03 14.7004 113.03 14.7204C113.03 15.1004 113.05 15.4704 113.08 15.8404C113.09 15.9904 113.11 16.1404 113.13 16.2904C113.15 16.4904 113.18 16.6904 113.21 16.8904C113.24 17.1004 113.28 17.3004 113.33 17.5004C113.35 17.5904 113.37 17.6804 113.39 17.7704C114.58 22.7404 118.6 26.5504 123.77 27.5604C124.15 27.6404 124.53 27.7004 124.92 27.7404V33.2804H127.69V27.7404C128.08 27.7004 128.46 27.6404 128.84 27.5604C134 26.5504 138.03 22.7404 139.21 17.7704C139.23 17.6804 139.25 17.5904 139.28 17.5004C139.32 17.3004 139.36 17.0904 139.4 16.8904C139.43 16.6904 139.46 16.4904 139.48 16.2904C139.5 16.1404 139.52 15.9904 139.53 15.8404C139.56 15.4704 139.58 15.1004 139.58 14.7204C139.58 14.7004 139.58 14.6804 139.58 14.6604V11.9604C139.58 11.1304 138.9 10.4404 138.06 10.4404H138.03Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid2",
    x1: 158.03,
    y1: 125.06,
    x2: 193.8,
    y2: 125.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid3",
    x1: 178.09,
    y1: 149.981,
    x2: 191.58,
    y2: 100.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid4",
    x1: 199.07,
    y1: 163.851,
    x2: 216.44,
    y2: 100.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid5",
    x1: 188.94,
    y1: 128.65,
    x2: 196.95,
    y2: 128.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid6",
    x1: 195.08,
    y1: 109.461,
    x2: 199.05,
    y2: 109.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid7",
    x1: 179.01,
    y1: 158.33,
    x2: 196.38,
    y2: 95.1802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid8",
    x1: 189.57,
    y1: 122.561,
    x2: 186.1,
    y2: 159.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid9",
    x1: 202.54,
    y1: 137.42,
    x2: 219.71,
    y2: 137.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid10",
    x1: 200.04,
    y1: 96.3305,
    x2: 200.04,
    y2: 77.6205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B85D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid11",
    x1: 205.24,
    y1: 96.3301,
    x2: 205.24,
    y2: 77.6201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B85D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid12",
    x1: 189.52,
    y1: 95.3203,
    x2: 203.31,
    y2: 95.3203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B85D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid13",
    x1: 202.28,
    y1: 123.75,
    x2: 198.81,
    y2: 160.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid14",
    x1: 202.18,
    y1: 123.6,
    x2: 224.37,
    y2: 136.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid15",
    x1: 214.67,
    y1: 134.97,
    x2: 210.17,
    y2: 134.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid16",
    x1: 181.451,
    y1: 132.453,
    x2: 176.91,
    y2: 132.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid17",
    x1: 176.83,
    y1: 92.0209,
    x2: 148.61,
    y2: 92.0209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3BEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1E5F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid18",
    x1: 123.45,
    y1: 161.461,
    x2: 123.45,
    y2: 143.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3BEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1E5F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid19",
    x1: 6.39,
    y1: 149.591,
    x2: 240.51,
    y2: 149.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3BEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1E5F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid20",
    x1: 115.02,
    y1: 141.521,
    x2: 151.13,
    y2: 141.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid21",
    x1: 100.11,
    y1: 152.28,
    x2: 143.21,
    y2: 152.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid22",
    x1: 94.12,
    y1: 174.21,
    x2: 94.12,
    y2: 223.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid23",
    x1: 66.39,
    y1: 113.77,
    x2: 85.06,
    y2: 113.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid24",
    x1: 96.44,
    y1: 164.85,
    x2: 96.44,
    y2: 222.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sid25",
    x1: 107.682,
    y1: 149.656,
    x2: 111.831,
    y2: 154.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sid26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.55,
    height: 33.28,
    fill: "white",
    transform: "translate(113)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectMic);
export default __webpack_public_path__ + "static/media/select_mic.4dfb757bb78ab27302c7d560b4783e9d.svg";
export { ForwardRef as ReactComponent };